import React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export function VarsityIcon({ fill = 'black', size = 'xsmall' }: IconProps) {
    const fillStyles = cn(Styles[fill], Styles.fill);

    return (
        <svg
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <path
                className={fillStyles}
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.6676 1.9591L19.0002 1.95167C19.6587 1.95075 20.1549 2.54992 20.0313 3.19664L15.8281 21.1966C15.7336 21.6908 15.3015 22.0482 14.7984 22.0482H9.22758C8.72493 22.0482 8.29304 21.6914 8.19817 21.1978L3.9723 3.20944C3.84806 2.56298 4.34343 1.96334 5.00171 1.96334H10.4524C10.9803 1.96334 11.4258 2.35582 11.4923 2.87945L12.0537 7.30092L12.6295 2.87231C12.6921 2.39066 13.0753 2.02071 13.5478 1.96607L13.6676 1.9591ZM13.9317 19.9509L17.7337 4.04992L14.5897 4.05392L12.3017 14.7757C12.2338 15.0936 11.7793 15.0916 11.7143 14.773L9.52771 4.05892H6.26971L10.0927 19.9509H13.9317Z"
            />
            <mask
                id="mask0_6029_9483"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="3"
                y="1"
                width="18"
                height="22"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.6676 1.95909L19.0002 1.95166C19.6587 1.95074 20.1549 2.54992 20.0313 3.19663L15.8281 21.1966C15.7336 21.6908 15.3015 22.0482 14.7984 22.0482H9.22758C8.72493 22.0482 8.29304 21.6914 8.19817 21.1978L3.9723 3.20943C3.84806 2.56298 4.34343 1.96334 5.00171 1.96334H10.4524C10.9803 1.96334 11.4258 2.35581 11.4923 2.87944L12.0537 7.30091L12.6295 2.87231C12.6921 2.39065 13.0753 2.02071 13.5478 1.96607L13.6676 1.95909ZM13.9317 19.9509L17.7337 4.04991L14.5897 4.05391L12.3017 14.7757C12.2338 15.0936 11.7793 15.0916 11.7143 14.773L9.52771 4.05891H6.26971L10.0927 19.9509H13.9317Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0_6029_9483)">
                <rect width="24" height="24" className={fillStyles} />
            </g>
        </svg>
    );
}
